import React from 'react';
import clsx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Dialog from './Dialog';
import { COLOR_BLUE, COLOR_DARK_BLUE } from '../styles/colors';
import { FONT_PROXIMA_NOVA } from '../styles/fonts';

interface ScoreDescriptionsModalProps {
  className?: string;
  headingClassName?: string;
  contentClassName?: string;
  isPopupVisible: boolean;
  onClose: () => void;
}

const useStyles = makeStyles((theme:Theme) => ({
  scoreDescriptionsModal: {},

  linksList: {
    margin: 0,
    padding: theme.spacing(0, 0, 0, 8.25),
    listStyle: 'none',
  },
  linkListItem: {
    '&:not(:first-of-type)': {
      marginTop: theme.spacing(2),
    },
  },

  icon: {
    width: 32,
    height: 32,
    marginRight: theme.spacing(2),
  },

  pdfLink: {
    display: 'flex',
    alignItems: 'center',
    color: COLOR_BLUE,
    textDecoration: 'underline',
    fontFamily: FONT_PROXIMA_NOVA,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: 1,

    '&:hover': {
      color: COLOR_DARK_BLUE,
    },
  },
}), { name: ScoreDescriptionsModal.name });

export default function ScoreDescriptionsModal (props:ScoreDescriptionsModalProps) {
  const {
    className,
    headingClassName,
    contentClassName,
    isPopupVisible,
    onClose,
  } = props;
  const classes = useStyles(props);

  return(
    <Dialog
      className={clsx(classes.scoreDescriptionsModal, className)}
      contentClassName={contentClassName}
      open={isPopupVisible}
      title='Score Descriptions'
      actions={[
        {
          name: 'Cancel',
          primary: false,
          onClick: onClose
        },
      ]}
      onClose={onClose}
    >
      <p className={headingClassName}>
        Learn more about PAI and Combine scores:
      </p>

      <ul className={classes.linksList}>
        <li className={classes.linkListItem}>
          <Link
            className={classes.pdfLink}
            to='/docs/pai-score-description.pdf'
            target='_blank'
          >
            <img
              className={classes.icon}
              src='/images/scores/pai-score.png'
            />
            PAI Score
          </Link>
        </li>

        <li className={classes.linkListItem}>
          <Link
            className={classes.pdfLink}
            to='/docs/combine-score-description.pdf'
            target='_blank'
          >
            <img
              className={classes.icon}
              src='/images/scores/combine-score.png'
            />
            HS Combine Score
          </Link>
        </li>

        <li className={classes.linkListItem}>
          <Link
            className={classes.pdfLink}
            to='/docs/ppi-score-description-2.pdf'
            target='_blank'
          >
            <img
              className={classes.icon}
              src='/images/scores/ppi-score.png'
            />
            PPI Score
          </Link>
        </li>

        <li className={classes.linkListItem}>
          <Link
            className={classes.pdfLink}
            to='/docs/pro-score-description.pdf'
            target='_blank'
          >
            <img
              className={classes.icon}
              src='/images/scores/pro-combine-score.png'
            />
            Pro Combine Score
          </Link>
        </li>
      </ul>
    </Dialog>
  );
}
